import script from "./UDropdownFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./UDropdownFilter.vue?vue&type=script&setup=true&lang=ts"

import "./UDropdownFilter.vue?vue&type=style&index=0&id=7697d9d8&lang=css"

const __exports__ = script;

export default __exports__